import { Injectable } from '@angular/core';
import { BotMessagesService } from './bot-messages.service';

@Injectable({
  providedIn: 'root'
})
export class InfoManagerService {

  constructor(
    private botMessagesService: BotMessagesService
  ) { }

  public messagesCount() {
    return this.botMessagesService.getMessageCount();
  }
}
